import gql from "graphql-tag";

export const MY_HR_GET_CHANGE_REQUESTS_BADGES = gql`
  query changeRequestsBadges($contract: String!) {
    changeRequestsBadges(contract: $contract)
  }
`;
